import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';

import ClinicalStudyDesignTabContents from '../clinical/ClinicalStudyDesignTabContents';
import ClinicalStudyExecutionOverview from '../clinical/ClinicalStudyExecutionOverview';
import ClinicalStudyOverviewTabContents from '../clinical/ClinicalStudyOverviewTabContents';
import {PreclinicalStudyState, StudySchema, TypedStudyAdapter} from '../utils/TypedStudyTypes';

export const PreclinicalStudyAdapter: TypedStudyAdapter<never, never, PreclinicalStudyState> = {
  type: StudyType.PRECLINICAL,

  isMultiProcedureRunEnabled: false,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: false,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: false,

  isVisualizationEnabled: false,

  allowReturnToDesignPhase: true,

  allowRequireDesignApproval: BenchlingConfig.STUDIES_ENABLE_REVIEW,

  modalOptions: (stepKey: never) => ({}),

  getButtonsByStep() {
    return null;
  },

  renderMetadataSection(state: PreclinicalStudyState) {
    return <></>;
  },

  getSteps: () => [],

  renderStep(key: never) {},

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: PreclinicalStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: PreclinicalStudyState) {
    return {};
  },
  creation: {
    async: false,
  },
  design: {
    ui: {
      tab: ClinicalStudyDesignTabContents,
    },
  },
  overview: {
    ui: {
      tab: ClinicalStudyOverviewTabContents,
      design: null,
      execution: ClinicalStudyExecutionOverview,
    },
  },
  review: {},
};
